import PersonalDetailsForm from './PersonalDetailsFormContainer';

export default PersonalDetailsForm;